<template>
  <div class="h-full rounded-lg flex flex-col overflow-hidden">
    <div class="h-full flex flex-col gap-2">
      
      <div class="flex-none  w-full overflow-hidden">
        <div
          v-if="validPermission('C0002')"
          class="flex items-center gap-4 w-full overflow-x-auto pb-2 scrollbar-tema rounded-lg"
        >
          <button
            v-if="validPermission('C0003')"
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'LigacaoBD' })"
          >
            <i class="fa-solid fa-database fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Ligação a BD</div>
          </button>

          <button
            v-if="validPermission('C0004')"
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'TabelasTipo' })"
          >
            <i class="fa-solid fa-table fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Tabelas Tipo</div>
          </button>

          <button
            v-if="validPermission('C0005')"
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'DadosEmpresa' })"
          >
            <i class="fa-solid fa-cogs fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Dados da Empresa</div>
          </button>

          <button
            v-if="validPermission('C0044')"
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'MudarPassword' })"
          >
            <i class="fa-solid fa-lock fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Mudar Password</div>
          </button>

          <button
            v-if="validPermission('C0006')"
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'DocumentosEmpresa' })"
          >
            <i class="fa-solid fa-file fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Documentos Empresa</div>
          </button>
          <button
            v-if="validPermission('C0091')"
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'Repositorio' })"
          >
            <i class="fa-solid fa-folder fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Repositório</div>
          </button>

          <button
            v-if="validPermission('C0072')"
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'Periodicidades' })"
          >
            <i class="fa-solid fa-clock fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Periodicidades</div>
          </button>

          <button
            v-if="validPermission('C0092')"
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'CapasTemplates' })"
          >
            <i class="fa-solid fa-image fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Capas e Templates</div>
          </button>

          <button
            v-if="validPermission('C0009')"
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'Feriados' })"
          >
            <i class="fa-solid fa-calendar fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Feriados</div>
          </button>

          <button
            v-if="validPermission('C0007')"
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'LigacaoMapas' })"
          >
            <i class="fa-solid fa-map fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Ligação a Mapas</div>
          </button>

          <!-- <button
            v-if="validPermission('C0008')"
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'Backup' })"
          >
            <i class="fa-solid fa-shield fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Backup</div>
          </button> -->

          <!-- <button
            style="background-color: var(--linhaLista)"
            class="btn flex-none"
            @click="triggerAction({ action: 'ThemeSwitcher' })"
          >
            <i class="fa-solid fa-palette fa-2xl" style="color: var(--iconCima)"></i>
            <div style="white-space: nowrap; color: var(--label)">Trocar Cor do Tema</div>
          </button> -->
        </div>
      </div>

      <div class="flex-1 min-h-0 w-full  rounded-b-lg">
        <div class="h-full overflow-y-auto  scrollbar-tema">
          <AppLigacaoBD v-if="LigacaoBD" />
          <AppTipoTabela v-if="TabelasTipo" :tipos="tipos" />
          <AppLigacaoMapas v-if="LigacaoMapas" />
          <AppDadosEmpresa v-if="DadosEmpresa" />
          <AppDocumentosEmpresa v-if="DocumentosEmpresa" />
          <AppRepositorio v-if="Repositorio" />
          <AppMudarPassword v-if="MudarPassword" />
          <AppAssiduidade
            v-if="Feriados"
            show="true"
            title="Feriados"
            mode="feriado"
            :holidays="feriados"
            @save="saveFeriado"
          />
          <AppThemeSwitcher v-if="ThemeSwitcher" />
          <AppPereodicidades v-if="Periodicidades" />
          <AppCapasTemplates v-if="CapasTemplates" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppThemeSwitcher from "@/components/AppThemeSwitcher.vue";

import AppProfileSearch from "@/components/profileSearch.vue";
import AppSearch from "@/components/search.vue";
import AppNotification from "@/components/notification.vue";
import AppActionCard from "@/components/actionCard.vue";
import AppFilter from "@/components/filter/filter.vue";
import AppLigacaoBD from "@/components/ligacaoBaseDados.vue";
import AppTipoTabela from "@/components/tipo/tipoTabela.vue";
import AppLigacaoMapas from "@/components/ligacaoMapas.vue";
import AppDadosEmpresa from "@/components/dadosEmpresa/DadosEmpresa.vue";
import AppAssiduidade from "@/components/calendario/assiduidade.vue";
import AppDocumentosEmpresa from "@/components/documentosEmpresa/DocumentosEmpresa.vue";
import AppRepositorio from "@/components/repositorio/Repositorio.vue";
import AppMudarPassword from "@/components/mudarPassword.vue";
import AppPereodicidades from "@/components/periodicidades/Periodicidade.vue"
import AppCapasTemplates from "@/components/capa_template/capa_template_manager.vue"

import axios from "axios";
import permissionMixin from "@/permissionMixin.js";
export default {
  mixins: [permissionMixin],
  name: "AppConfiguracoes",
  components: {
    AppThemeSwitcher,
    AppProfileSearch,
    AppSearch,
    AppNotification,
    AppActionCard,
    AppFilter,
    AppLigacaoBD,
    AppTipoTabela,
    AppLigacaoMapas,
    AppDadosEmpresa,
    AppAssiduidade,
    AppDocumentosEmpresa,
    AppMudarPassword,
    AppPereodicidades,
    AppCapasTemplates,
    AppRepositorio
  },

  data() {
    return {
      ThemeSwitcher: false,
      baseURl: process.env.VUE_APP_URL_BASE,
      tipos: [],
      show_action_card: true,

      feriados: [],
      LigacaoBD: true,
      TabelasTipo: false,
      LigacaoMapas: false,
      Backup: false,
      DadosEmpresa: false,
      Feriados: false,
      DocumentosEmpresa: false,
      MudarPassword: false,
      Periodicidades: false,
      CapasTemplates: false,
      Repositorio: false,
      tipos: [
        { nome: "Utilizador", codigo: "C0015" },
        { nome: "Cliente", codigo: "C0030" },
        { nome: "Viatura", codigo: "C0016" },
        { nome: "Zona", codigo: "C0017" },
        { nome: "IVA", codigo: "C0032" },
        { nome: "Contacto", codigo: "C0018" },
        { nome: "Valencia", codigo: "C0033" },
        { nome: "Armazem", codigo: "C0019" },
        { nome: "Tarefa", codigo: "C0034" },
        // Colocar codigo real do separador
        { nome: "Separador", codigo: "C0074" },
        { nome: "Serviço", codigo: "C0020" },
        { nome: "Artigo", codigo: "C0035" },
        { nome: "Marca", codigo: "C0036" },
        { nome: "Pagamento", codigo: "C0022" },
        { nome: "Prazo", codigo: "C0037" },
        { nome: "Moeda", codigo: "C0023" },
        { nome: "Documento", codigo: "C0038" },
        { nome: "Movimento", codigo: "C0024" },
        { nome: "Ticket", codigo: "C0039" },
        { nome: "Notificação", codigo: "C0025" },
        { nome: "Medida", codigo: "C0040" },
        { nome: "Orçamento", codigo: "C0026" },
        { nome: "Tipologia", codigo: "C0041" },
        { nome: "Relatório", codigo: "C0027" },
        { nome: "Area", codigo: "C0042" },
        { nome: "Repositório", codigo: "C0028" },
        { nome: "Prioridade", codigo: "C0043" },
        { nome: "Rejeição", codigo: "C0029" },
        { nome: "Directorias", codigo: "C0031" },
        { nome: "Variáveis", codigo: "C0021" },
        // mudar codigo de variaveis subcliente
        { nome: "Variável Subcliente", codigo: "C0021" },
        { nome: "ModoContato", codigo: "C0075" },
        { nome: "Contrato", codigo: "C0076" },
        { nome: "Ação", codigo: "C0073" },
        { nome: "Proposta", codigo: "C0079" },
        { nome: "EstadoProposta", codigo: "C0080" },
        { nome: "EstadoOrçamento", codigo: "C0081" },
        { nome: "CondiçõesOrçamento", codigo: "C0084" },
        { nome: "EstadoEncomenda", codigo: "C0086" },
        { nome: "EstadoCompra", codigo: "C0086" },
        { nome: "EstadoArmazemLocal", codigo: "C0086" },
        { nome: "Encomenda", codigo: "C0088" },
        { nome: "EstadoValidação", codigo: "C0089" },
        // mudar codigo de negocio
        { nome: "Negocio", codigo: "C0026" },
      ],
    };
  },
  created() {
    this.fetchTipos();
    this.fetchFeriados();

    this.tipos = this.tipos.sort((a, b) => a.nome.localeCompare(b.nome));
  },
  methods: {
    triggerAction({ action }) {
      this.setActive(action);
    },
    setActive(viewSelected) {
      const variables = [
        "LigacaoBD",
        "TabelasTipo",
        "LigacaoMapas",
        "Backup",
        "DadosEmpresa",
        "DocumentosEmpresa",
        "MudarPassword",
        "Feriados",
        "ThemeSwitcher",
        "Periodicidades",
        "CapasTemplates",
        "Repositorio"
      ];
      variables.forEach((variable) => {
        this[variable] = variable === viewSelected;
      });
    },
    fetchTipos() {
      // const url = "http://
    },
    close_action_card() {
      this.show_action_card = false;
    },
    async saveFeriado(date) {
      date.map(async (date) => {
        const send_feriado = {
          nome:
            date.descricao && date.descricao !== ""
              ? date.descricao
              : "Sem Nome",
          data: date.data,
          status: date.status,
          tpArea_id: date.tpArea_id ? date.tpArea_id : 0,
        };
        if (date.action && date.action == "updated") {
          await this.update(
            `${this.baseURl}/api/v1/tpferiado/editar/${date.id}/`,
            send_feriado
          );
          this.fetchFeriados();
        } else if (date.action && date.action === "novo") {
          await this.create(
            send_feriado,
            `${this.baseURl}/api/v1/tpferiado/registrar/`
          );
          this.fetchFeriados();
        }
      });
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      console.log("data to update:", data);

      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return true;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async fetchFeriados() {
      this.feriados = [];
      let res = await this.select(`${this.baseURl}/api/v1/tpferiado/`);
      if (res) {
        this.feriados = res.map((value) => ({
          id: value.id,
          descricao: value.nome,
          data: value.data,
          status: value.status,
          tpArea_id: value.tpArea_id,
        }));
      }
    },
    triggerAction({ action }) {
      this.setActive(action);
    },
  },
};
</script>

<style scoped>
.btn {
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: var(--icon); /* ou qualquer outra cor que desejar */
}

.btn:hover i {
  color: var(--label); /* muda a cor do ícone */
}

.btn:hover div {
  color: var(--text); /* muda o texto abaixo do ícone */
}
</style>
